<script>/*eslint-disable*/</script>
<template>
	<div class="modal">
		<button class="close" @click="closeModal"></button>
		<div class="modal__container" v-html="fetchModalContent()">
			{{fetchModalContent()}}
		</div>
	</div>
</template>

<style lang="scss">
.modal {
	position: fixed;
	width: rem(650);
	max-width: 100%;
	padding: rem(30);
	left: 50%;
	top: 50%;
	background: $white;
	transform: translate(-50%, -48%);
	z-index: -1;
	opacity: 0;
	transition: 0.2s opacity, 
		1s transform;

	max-height: 100vh;
    overflow: auto;		

	.modal__title {
		color: $blueTwo;
		font-size: rem(24);

		@include bp($bp-small-up) {
			font-size: rem(40);
		}
	}

	&__container {
		position: relative;
		height: calc(100% - 30px);
		padding: 0 rem(20) 0 0;
		margin: rem(30) 0 0;
		overflow: auto;
		text-align: center;
		
		p{
			font-size: rem(16);
		}
	}

	.modal-open & {
		opacity: 1;
		transform: translate(-50%, -50%);
		z-index: 100;
	}
}

.close {
	position: absolute;
	width: rem(30);
	height: rem(30);
	right: rem(20);
	top: rem(20);

	&:before,
	&:after{
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: rem(30);
		height: rem(3);
		background-color: $blueTwo;
		transform: translateY(15px) rotate(45deg);
		transform-origin: 50% 50%;
	}

	&:after {
		transform: translateY(15px) rotate(-45deg);
	}
}

</style>

<script>
import store from '../store';
import modalObject from '../modalContent';

export default {
	props: ['modalTag'],
	methods: {
		closeModal() {
			const body = document.querySelector('body');
			body.className = '';
		},
		fetchModalContent() {
			return(
				modalObject.content[this.modalTag]
			);
		}
    },
};
</script>
